module.exports = __webpack_public_path__ + "img/mC-big-V4.d6e849a5.png";